import { useSyncExternalStore } from "react";

// Small per-device preferences (theme, sound), kept in localStorage and
// readable from React. Storage can be blocked; the defaults still work.

export function createPref<T extends string>(key: string, fallback: () => T, valid: readonly T[]) {
  const listeners = new Set<() => void>();
  let value: T = fallback();
  try {
    const stored = localStorage.getItem(key) as T | null;
    if (stored && valid.includes(stored)) value = stored;
  } catch {
    // Keep the fallback.
  }
  return {
    get: () => value,
    set(next: T) {
      value = next;
      try {
        localStorage.setItem(key, next);
      } catch {
        // Not persisted; still applies to this page.
      }
      listeners.forEach((l) => l());
    },
    use(): T {
      return useSyncExternalStore(
        (l) => {
          listeners.add(l);
          return () => listeners.delete(l);
        },
        () => value,
      );
    },
  };
}
